// extracted by mini-css-extract-plugin
export var image_wrapper = "staticImageContainer-module--image_wrapper--02d02";
export var set_absolute = "staticImageContainer-module--set_absolute--a66b5";
export var visible = "staticImageContainer-module--visible--5f6de";